import ClassNames from "classnames";
import * as React from "react";

import Styles from "./UnorderedList.module.css";

export interface Props {
  listClassName?: string;
  children: React.ReactNode[];
  variant?: "unstyled" | "icon";
  inline?: boolean;
}

const UnorderedList: React.FC<Props> = props => {
  const { listClassName, children, variant, inline } = props;

  return (
    <ul
      className={ClassNames({
        [Styles.unorderedlist]: true,
        [Styles[variant]]: true,
        [Styles.inline]: inline,
        [listClassName]: listClassName
      })}
    >
      {children}
    </ul>
  );
};

export default UnorderedList;
